import { ArrowBackOutlined, DescriptionOutlined, FolderOutlined, KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import { Box, Button, Checkbox, IconButton, TextField, Typography, useTheme } from '@mui/material';
import React from 'react'
import { Tree } from 'react-arborist';
import AutoSizer from 'react-virtualized-auto-sizer';
import { font } from '../../../styles/font';
import { LightTooltip } from '../../styled/CustomComponent';
import { useState } from 'react';
import { useApplicationContext } from '../../../context/ApplicationContext';
import GraphComponent from './GraphComponent';
import { grey } from '@mui/material/colors';

class LocalEntity {
    static folder = "folder";
    static useCase = "useCase";
    static userStory = "userStory";
    static testCase = "testCase";
}

export default function CreateGraphComponent({ onClose }) {
    const theme = useTheme();
    const [selectedItemsList, setSelectedItemsList] = useState([]); // to make section of checkbox

    const list = [
        {
            name: "Folder1",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]

        },
        {
            name: "Folder2",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder3",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder4",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder5",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        }
    ];



    const folderList = [
        {
            "id": "4ff39588-cbc0-4f7a-92b9-0c3dd38e6ec4",
            "name": "Default",
            "description": null,
            "path": "default",
            "section": "UseCase",
            "type": "UseCase",
            "children": [
                {
                    "id": "09efa887-694f-4ecc-b980-d1e490e4c674",
                    "name": "l-d1",
                    "description": null,
                    "path": "default/l-d1",
                    "section": "UseCase",
                    "type": "UseCase",
                    "children": [],
                    "userStoryCount": 0,
                    "useCaseCount": 2,
                    "testCaseCount": 0,
                    "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
                },
                {
                    "id": "b76d072c-5cfc-4871-be6a-9bfb14f83c0d",
                    "name": "folder2",
                    "description": null,
                    "path": "default/folder2",
                    "section": "UseCase",
                    "type": "UseCase",
                    "children": [],
                    "userStoryCount": 0,
                    "useCaseCount": 0,
                    "testCaseCount": 0,
                    "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
                }
            ],
            "userStoryCount": 0,
            "useCaseCount": 11,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "162cdc40-6736-474a-bcb5-d6b1ed02ba52",
            "name": "folder2",
            "description": null,
            "path": "folder2",
            "section": "UseCase",
            "type": "UseCase",
            "children": [
                {
                    "id": "9bfe62b3-e50f-4341-96ba-f39d90f56346",
                    "name": "folder2_sub",
                    "description": null,
                    "path": "folder2/folder2_sub",
                    "section": "UseCase",
                    "type": "UseCase",
                    "children": [],
                    "userStoryCount": 0,
                    "useCaseCount": 0,
                    "testCaseCount": 0,
                    "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
                },
                {
                    "id": "33919137-8cc8-445d-b63c-26d13b7861a3",
                    "name": "jksdfdsf",
                    "description": null,
                    "path": "folder2/jksdfdsf",
                    "section": "UseCase",
                    "type": "UseCase",
                    "children": [],
                    "userStoryCount": 0,
                    "useCaseCount": 0,
                    "testCaseCount": 0,
                    "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
                }
            ],
            "userStoryCount": 0,
            "useCaseCount": 1,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "75e9e43e-7800-49fb-ae05-8a50a7a38360",
            "name": "folder3",
            "description": null,
            "path": "folder3",
            "section": "UseCase",
            "type": "UseCase",
            "children": [],
            "userStoryCount": 0,
            "useCaseCount": 0,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "0976d907-c42f-47e2-81d3-a066a285bc2b",
            "name": "folder4",
            "description": null,
            "path": "folder4",
            "section": "UseCase",
            "type": "UseCase",
            "children": [],
            "userStoryCount": 0,
            "useCaseCount": 0,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "61f248af-b421-48ec-8192-13d1240eb3b7",
            "name": "folder 5",
            "description": null,
            "path": "folder 5",
            "section": "UseCase",
            "type": "UseCase",
            "children": [],
            "userStoryCount": 0,
            "useCaseCount": 0,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "c2abad28-4521-4d16-9520-0ae97fe665d3",
            "name": "folder6",
            "description": null,
            "path": "folder6",
            "section": "UseCase",
            "type": "UseCase",
            "children": [],
            "userStoryCount": 0,
            "useCaseCount": 0,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        }
    ];


    const handleChangeSelection = (e, itemData) => {
        console.log(itemData, "itemDatatop", e.target.value)

        if (itemData?.type === LocalEntity.folder) {
            console.log(itemData, "itemDatatop folder")
            if (e.target.checked) {

                let selectedList = [...selectedItemsList];
                // selectedList = selectedList.concat(addChildren(itemData, selectedList));
                setSelectedItemsList(selectedList);

                console.log("folder result list add", selectedList, selectedItemsList)
            } else {

                let selectedList = [...selectedItemsList];
                // selectedList = removeChildren(itemData, selectedList);
                setSelectedItemsList(selectedList);

                console.log("folder result list remove", selectedList, selectedItemsList)
            }
        } else {
            console.log(itemData, "itemDatatop items")
            if (e.target.checked) {
                let selectedList = [...selectedItemsList];

                let foundIndex = selectedList?.findIndex((data) => data?.customId === itemData?.customId && data?.folderPath === itemData?.folderPath);

                if (foundIndex === -1) {
                    selectedList.push(itemData);
                }

                setSelectedItemsList(selectedList);
                console.log("item result list add", selectedList, selectedItemsList)


            } else {
                let list = selectedItemsList;
                list = list?.filter((data) => !(data.customId === itemData.customId && data.folderPath === itemData.folderPath));
                setSelectedItemsList(list);

                console.log("item result list remove", list, selectedItemsList, itemData, e.target.value)
            }
        }
    }

    const handleClose = () => {
        onClose();
    }

    return (
        <Box className=" flex flex-col gap-0 w-full h-full overflow-hidden" borderRadius={theme.shape.borderRadius} bgcolor={theme.palette.background.paper}>
            <Box className="flex items-center justify-between gap-4 px-4 py-2 border-b">
                <IconButton onClick={handleClose}>
                    <ArrowBackOutlined />
                </IconButton>
                {/* <Typography fontSize={font.size.fs_5} color="textSecondary" className="flex-1  ">Create Graph</Typography> */}

                <TextField placeholder="Title" fullWidth />
                <Box className="flex items-center px-0 py-2 border-t">
                    <Button variant="contained" fullWidth color="secondary" sx={{ color: theme.palette.secondary.contrastText }}>Save</Button>
                </Box>

                {/* <IconButton>
                    <SaveOutlined />
                </IconButton> */}
            </Box>

            <Box className="flex-1 flex items-center gap-0 overflow-auto divide-x" >

                {/* folder list */}
                <Box className="flex flex-col gap-4 h-full w-[40%]">

                    <Box className="flex-1 flex flex-col px-4 py-2">
                        <AutoSizer>
                            {({ height, width }) => {
                                console.log(height, width, "heightwidth")
                                return (
                                    <Tree
                                        initialData={folderList}
                                        openByDefault={true}
                                        width={width}
                                        height={height}
                                        indent={24}
                                        rowHeight={48}
                                    // overscanCount={1}
                                    // paddingTop={30}
                                    // paddingBottom={10}
                                    // padding={25 /* sets both */}
                                    >
                                        {({ node, style, dragHandle }) => (
                                            <Node node={node} style={style} dragHandle={dragHandle} selectedItemsList={selectedItemsList} handleChangeSelection={handleChangeSelection} />
                                        )}
                                    </Tree>

                                )
                            }}
                        </AutoSizer>
                    </Box>
                </Box>

                {/* preview button */}
                <Box className="flex flex-col items-center justify-center px-2 py-2 h-full" bgcolor={theme.palette.background.custom}>
                    <Button variant="contained" color="secondary" sx={{ color: theme.palette.secondary.contrastText, }}>
                        Preview
                    </Button>
                </Box>


                {/* graph container */}
                <Box className="flex-1 flex flex-col px-4 py-2 gap-4 h-full">

                    <GraphComponent title={`Graph`} list={list} style={{ width: "100%", height: "100%" }} />

                </Box>

            </Box>
        </Box>
    )
}


function Node({ node, style, dragHandle, selectedItemsList, handleChangeSelection }) {
    const { activeProject, isUpdateFolderStructure, setIsUpdateFolderStructure, currentFolderAnchorEl, setCurrentFolderAnchorEl } = useApplicationContext();
    const theme = useTheme();



    const handleFolderClick = (folder) => {
    }

    const handleIconClick = (folder) => {
        folder.toggle();
    }

    const handleRightClick = (event, folder) => {
        event.preventDefault();
    }

    const checkChecked = () => {
        let isChecked = false;
        let isInderminate = false;

        if (node.data.type === LocalEntity.folder) {
            isChecked = checkFolderItems(node?.data)?.isChecked;
            isInderminate = checkFolderItems(node?.data)?.isIndeterminated;
            // isChecked = node?.data?.children?.every((child) => selectedItemsList?.includes(child?.customId));
            // isInderminate = selectedItemsList?.some((item) => node?.data?.children?.some((child) => child?.customId === item)) && !isChecked

        } else {
            let foundItem = selectedItemsList?.find((data) => data?.customId === node?.data?.customId && data?.folderPath === node?.data?.folderPath);
            isChecked = Boolean(foundItem);
            isInderminate = false
        }

        return { isChecked, isInderminate }
    }


    function checkFolderItems(folder) {
        let totalItemsCount = 0;
        let checkedItemsCount = 0;
        let isIndeterminated = false;

        if (folder?.children?.length === 0) {
            return { isChecked: false, isIndeterminated: false, totalItemsCount: 0, checkedItemsCount: 0 };
        }

        folder?.children?.forEach((item) => {
            if (item?.type === LocalEntity.folder) {
                const {
                    totalItemsCount: childTotalCount,
                    checkedItemsCount: childCheckedCount
                } = checkFolderItems(item);
                totalItemsCount += childTotalCount;
                checkedItemsCount += childCheckedCount;
                if (childCheckedCount > 0 && childCheckedCount < childTotalCount) {
                    isIndeterminated = true;
                }
            } else {
                totalItemsCount++;
                const foundItem = selectedItemsList?.find((data) =>
                    data?.customId === item?.customId &&
                    data?.folderPath === item?.folderPath
                );
                if (foundItem) {
                    checkedItemsCount++;
                }
            }
        });

        const isChecked = totalItemsCount === checkedItemsCount;
        if (checkedItemsCount > 0 && checkedItemsCount < totalItemsCount) {
            isIndeterminated = true;
        }

        return {
            isChecked,
            isIndeterminated,
            totalItemsCount,
            checkedItemsCount
        };
    }

    function checkFolderItems1(folder) {
        let totalItemsCount = 0;
        let checkedItemsCount = 0;
        let isIndeterminated = false;

        folder?.children?.forEach((item) => {
            if (item?.type === LocalEntity.folder) {
                const { totalItemsCount: childTotalCount, checkedItemsCount: childCheckedCount } = checkFolderItems(item);
                totalItemsCount += childTotalCount;
                checkedItemsCount += childCheckedCount;
                if (childCheckedCount > 0 && childCheckedCount < childTotalCount) {
                    isIndeterminated = true;
                }
            } else {
                totalItemsCount++;
                const foundItem = selectedItemsList?.find((data) =>
                    data?.customId === item?.customId &&
                    data?.folderPath === item?.folderPath
                );
                if (foundItem) {
                    checkedItemsCount++;
                }
            }
        });

        const isChecked = totalItemsCount === checkedItemsCount;
        if (checkedItemsCount > 0 && checkedItemsCount < totalItemsCount) {
            isIndeterminated = true;
        }

        return { isChecked, isIndeterminated, totalItemsCount, checkedItemsCount };
    }

    function checkFolderItems2(folder) {
        let totalItemsCount = 0;
        let checkedItemsCount = 0;
        let isChecked = true;
        let isIndeterminated = checkedItemsCount > 0 && checkedItemsCount < totalItemsCount;

        folder?.children?.forEach((item) => {
            if (item?.type === LocalEntity.folder) {
                const { isChecked: childChecked, isIndeterminated: childIndeterminated } = checkFolderItems(item);
                if (!childChecked) {
                    isChecked = false;
                }
                if (childIndeterminated) {
                    isIndeterminated = true;
                }
            } else {
                const foundItem = selectedItemsList?.find((data) => data?.customId === item?.customId && data?.folderPath === item?.folderPath);
                totalItemsCount = totalItemsCount + 1;
                checkedItemsCount = checkedItemsCount + 1;
                if (!foundItem) {
                    isChecked = false;
                    checkedItemsCount = checkedItemsCount - 1;
                    // isIndeterminated = true;
                }
            }
        });

        return { isChecked, isIndeterminated };
    }



    console.log(node, "nodegraph");

    console.log(currentFolderAnchorEl, "folderAnchorEl");


    return (
        <Box
            className={`flex items-center gap-1 py-1 px-2 cursor-pointer`}
            borderRadius={theme.shape.borderRadius}
            // style={style}
            // ref={dragHandle}
            // onClick={() => { handleFolderClick(node) }}
            sx={{
                // color: (currentFolderData?.id === node?.id) && theme.palette.secondary.contrastText,
                // background: (currentFolderData?.id === node?.id) && "rgba(0, 0, 0, 0.05)" 
                pl: (node.level * 4)
                // pl : (node.level * 2)
            }}

        >

            <Box className="" onClick={() => handleIconClick(node)}>
                {!node.isLeaf &&
                    (node.isOpen ?
                        <KeyboardArrowDown /> : <KeyboardArrowRight />
                    )
                }
            </Box>


            <Box className="flex-1 flex items-center gap-1 " borderRadius={theme.shape.borderRadius} bgcolor={grey[100]} onClick={() => handleFolderClick(node)} sx={{ pl: 0 }} onContextMenu={(e) => handleRightClick(e, node)}>

                {
                    console.log(
                        (node.data.type === "use_case" || node.data.type === "user_story") && selectedItemsList?.some((item, index) => {
                            console.log(item, index, "item some checkbox")
                            return item === node?.data?.customId
                        }),
                        "checkbox selectedItemsList",
                        node?.data?.customId,
                        selectedItemsList
                    )
                }

                {/* {node.data.type === FolderType.project &&
                    <Checkbox
                        size="small"
                        checked={checkChecked()?.isChecked}
                        indeterminate={checkChecked()?.isInderminate}
                        onChange={(e) => handleChangeSelection(e, node?.data)}
                    />
                }

                {node.data.type === FolderType.module &&
                    <Checkbox
                        size="small"
                        checked={checkChecked()?.isChecked}
                        indeterminate={checkChecked()?.isInderminate}
                        onChange={(e) => handleChangeSelection(e, node?.data)}
                    />
                }

                {(node.data.type === "use_case" || node.data.type === "user_story") &&
                    <Checkbox
                        size="small"
                        checked={checkChecked()?.isChecked}
                        onChange={(e) => handleChangeSelection(e, node?.data)}
                    />
                } */}

                <Checkbox
                    size="small"
                    checked={checkChecked()?.isChecked}
                    indeterminate={checkChecked()?.isInderminate}
                    onChange={(e) => handleChangeSelection(e, node?.data)}
                />


                {node.data.type === LocalEntity.folder &&
                    <FolderOutlined sx={{ fontSize: font.size.fs_3 }} />
                }

                {(node.data.type === LocalEntity.useCase || node.data.type === LocalEntity.userStory) &&
                    <DescriptionOutlined sx={{ fontSize: font.size.fs_3 }} />
                }

                <LightTooltip
                    title={<Box className="flex-1 flex items-center gap-2 ">

                        <Typography fontSize={font.size.fs_5} className="">
                            {`${node.data.name} `}
                        </Typography>
                    </Box>}
                    arrow
                    placement="right"
                >
                    <Box className="flex-1 flex flex-col justify-between gap-0 overflow-hidden ml-2">

                        <Typography fontSize={font.size.fs_6} lineHeight={font.size.fs_5} className="line-clamp-1 ">
                            {`${node.data.name} `}
                        </Typography>
                    </Box>
                </LightTooltip>
            </Box>


        </Box>
    );
}